
import { defineComponent, computed } from 'vue'
import { RESOLUTIONS } from '@/components/common/CameraResolutionSelector.vue'

const PREV_LABELS = {
  [RESOLUTIONS.RUISEKI]: '前月',
  [RESOLUTIONS.MINUTE]: '5分前',
  [RESOLUTIONS.HOUR]: '1時間前',
  [RESOLUTIONS.DAY]: '前日',
  [RESOLUTIONS.MONTH]: '前月',
  [RESOLUTIONS.TEN_MIN]: '2時間前',
}

const NEXT_LABELS = {
  [RESOLUTIONS.RUISEKI]: '翌月',
  [RESOLUTIONS.MINUTE]: '5分後',
  [RESOLUTIONS.HOUR]: '1時間後',
  [RESOLUTIONS.DAY]: '翌日',
  [RESOLUTIONS.MONTH]: '翌月',
  [RESOLUTIONS.TEN_MIN]: '2時間後',
}

const TODAY_LABELS = {
  [RESOLUTIONS.RUISEKI]: '今月',
  [RESOLUTIONS.MINUTE]: '現在',
  [RESOLUTIONS.HOUR]: '現在',
  [RESOLUTIONS.DAY]: '今日',
  [RESOLUTIONS.MONTH]: '今月',
  [RESOLUTIONS.TEN_MIN]: '現在時刻',
}

export default defineComponent({
  props: {
    resolution: {
      type: String,
      default: RESOLUTIONS.MINUTE,
    },
  },
  setup(props, { emit }) {
    const prevLabel = computed(() => PREV_LABELS[props.resolution])
    const todayLabel = computed(() => TODAY_LABELS[props.resolution])
    const nextLabel = computed(() => NEXT_LABELS[props.resolution])

    const move = (tag: string) => {
      emit(tag)
    }

    return {
      prevLabel,
      todayLabel,
      nextLabel,
      move,
    }
  },
})
